import React from "react";
import { Field } from "formik";
import FormContainer from "forms/components/FormContainer";
import FormRow from "forms/components/FormRow";
import { CheckboxField, PeriodField, PriceField, SpaceField } from "forms/fields";
import SpaceSizeEdit from "forms/SpaceForm/SpaceSizeEdit";
import isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import DeleteItem from "rialto-icons/DeleteItem";
import { spaceShape } from "shapes";

import AddButton from "components/AddButton";
import IconButton from "components/IconButton";
import { Translate } from "utils";
import { createProposalSpace } from "utils/proposals";

import styles from "../ProposalForm.css";

const { t } = new Translate("Proposal");

const ProposalSpace = ({ defaultUnits, field, index, onAdd, onRemove, space, spaces }) => {
  const isSelected = !isEmpty(space);

  return (
    <FormContainer title={t("space")}>
      {isSelected && <IconButton icon={DeleteItem} onClick={onRemove} />}
      <FormRow>
        <Field
          component={SpaceField}
          isMultiple={false}
          name={field.name}
          normalize={(s) => s && createProposalSpace(s, defaultUnits)}
          spaces={spaces}
        />
        {!isEmpty(space) && (
          <Field
            component={SpaceSizeEdit}
            name={field.name}
            spaceCategory={space.category || "office"}
          />
        )}
      </FormRow>

      {isSelected && index > 0 && (
        <FormRow columns={1}>
          <Field
            component={CheckboxField}
            label={t("firstRefusalRight")}
            name={`${field.name}.firstRefusalRight`}
          />
        </FormRow>
      )}

      {isSelected && !space.firstRefusalRight && (
        <>
          <FormRow columns={1}>
            {space.price ? (
              <Field
                component={PriceField}
                name={`${field.name}.price`}
                onRemove={() => field.onChange({ ...field.value, price: null })}
                spaceCategory={space.category}
                hideMinContractLength
              />
            ) : (
              <AddButton
                label={t("addPrice")}
                onClick={() => field.onChange({ ...field.value, price: { ...defaultUnits } })}
              />
            )}
          </FormRow>
          <FormRow columns={1}>
            <Field
              component={PeriodField}
              label={t("rentFreePeriod")}
              name={`${field.name}.rentFreePeriod`}
              isInline
            />
          </FormRow>
        </>
      )}

      {isSelected && (
        <button className={styles.addSpace} onClick={onAdd} type="button">
          {t("addSpace")}
        </button>
      )}
    </FormContainer>
  );
};

ProposalSpace.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
  }),
  index: PropTypes.number.isRequired,
  space: PropTypes.shape(spaceShape),
  spaces: PropTypes.arrayOf(PropTypes.shape(spaceShape)),
  defaultUnits: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    period: PropTypes.string.isRequired,
    sizeUnit: PropTypes.string.isRequired,
  }).isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default ProposalSpace;
